export default {
    path: '/pushmsg',
    meta: {
        title: '消息详情',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/pushmsg`),
}


// WEBPACK FOOTER //
// ./src/views/PushMsg/router.js